<template>
  <b-card body>
    <div v-if="!menuAddProduct">
      <div class="d-flex justify-between mb-2">
        <div class="d-flex items-center">
          <b-button
            variant="primary"
            size="sm"
            class="mr-1 rounded-lg p-0"
            @click="$router.go(-1)"
          >
            <feather-icon
              size="2x"
              icon="ChevronLeftIcon"
            />
          </b-button>
          <h4 class="font-bold text-black d-inline-flex mb-0">
            Ajukan Penarikan Barang
          </h4>
        </div>
        <b-button
          :variant="handleDisableAjukan() ? 'secondary' : 'primary'"
          :disabled="handleDisableAjukan()"
          @click="confirmAjukan"
        >
          Ajukan Penarikan Barang
        </b-button>
      </div>
      <div class="flex items-center">
        <div class="w-[20%] text-[16px] text-black">
          Dikirim dari
        </div>
        <v-select
          v-model="warehouse"
          placeholder="Pilih Gudang"
          class="w-[70%]"
          :options="gudangList"
          :reduce="gudang => gudang.value"
          :selectable="gudang => !gudang.disabled"
          :clearable="false"
          @input="stokProduk = [], fetcherProducts.fetchData({ reset: true })"
        />
      </div>
      <div class="flex items-center mt-1">
        <div class="w-[20%]" />
        <div class="w-[70%] d-flex">
          <b-button
            :variant="ekspedisi ? 'outline-primary' : 'outline-dark'"
            class="d-flex align-items-center mr-1"
            size="sm"
            @click="onClickEkspedisi"
          >
            <b-img :src="ekspedisi ? `https://storage.googleapis.com/komerce/assets/menggunakan-ekspedisi-orange.svg` : `https://storage.googleapis.com/komerce/assets/dikirimekpedisi.svg`" />
            <span class="ml-1">Dikirim Ekspedisi</span>
          </b-button>
          <b-button
            :variant="sendiri ? 'outline-primary' : 'outline-dark'"
            class="d-flex align-items-center"
            size="sm"
            @click="onClickSendiri"
          >
            <b-img :src="sendiri ? `https://storage.googleapis.com/komerce/assets/dikirim-sendiri-orange.svg` : `https://storage.googleapis.com/komerce/assets/ekpedisidikirim-pribadi.svg`" />
            <span class="ml-1">Diambil Sendiri</span>
          </b-button>
        </div>
      </div>
      <div v-if="ekspedisi">
        <div class="flex items-start mt-1">
          <div class="w-[20%] text-[16px] text-black mt-[3px]">
            Nama Penerima
          </div>
          <div class="w-[70%]">
            <b-input
              v-model="receiverName"
              placeholder="Masukkan nama penerima"
              :formatter="formatReceiverName"
            />
            <small
              :class="receiverName.length === 30 ? 'text-primary' : ''"
              class="float-right mt-[3px]"
            >{{ receiverName.length }}/30</small>
            <small
              :class="errorInputName ? 'text-primary' : ''"
              class="float-left mt-[3px]"
            >{{ errorInputName }}</small>
          </div>
        </div>
        <div class="flex items-start mt-1">
          <div class="w-[20%] text-[16px] text-black mt-[3px]">
            No.Hp
          </div>
          <div class="w-[70%]">
            <b-input-group
              prepend="+62"
            >
              <b-input
                v-model="receiverPhone"
                number
                :formatter="formatPhoneNumber"
              />
            </b-input-group>
            <small
              :class="errorInputPhone ? 'text-primary' : ''"
              class="float-left mt-[3px]"
            >{{ errorInputPhone }}</small>
          </div>
        </div>
        <div class="flex items-center mt-1">
          <div class="w-[20%] text-[16px] text-black">
            Alamat Tujuan
          </div>
          <div class="w-[70%]">
            <v-select
              v-model="receiverDestinationId"
              :clearable="false"
              placeholder="Masukkan kelurahan/kecamatan"
              :loading="loadingDestinations"
              :options="destinations"
              @search="searchDestination"
            />
          </div>
        </div>
        <div class="flex items-start mt-1">
          <div class="w-[20%] text-[16px] text-black">
            Alamat Detail
          </div>
          <div class="w-[70%]">
            <b-textarea
              v-model="receiverAddressDetail"
              rows="3"
              placeholder="Agar kurir mudah menemukan lokasi, Masukkan nama jalan, RT / RW atau patokan bangunan dengan lengkap ya"
              :formatter="formatAddressDetail"
            />
            <small
              :class="receiverAddressDetail.length === 185 ? 'text-primary' : ''"
              class="float-right mt-[3px]"
            >{{ receiverAddressDetail.length }}/185</small>
            <small
              :class="errorAddressDetail ? 'text-primary' : ''"
              class="float-left mt-[3px]"
            >{{ errorAddressDetail }}</small>
          </div>
        </div>
      </div>
      <div v-if="sendiri">
        <div class="flex items-center mt-1">
          <div class="w-[20%] text-[16px] text-black">
            Tanggal Pengambilan
          </div>
          <div class="w-[70%]">
            <b-input-group class="">
              <flat-pickr
                ref="pickupDate"
                v-model="pickupDate"
                class="form-control"
                :config="configDate"
              />
              <b-input-group-append
                role="button"
                is-text
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/icons/date-picker-icon.svg"
                  @click="$refs.pickupDate.fp.toggle()"
                >
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>
      </div>
      <div class="border-t text-black text-[16px] mt-2 flex justify-between items-center">
        <div>Stok Produk</div>
        <b-button
          class="mt-[10px]"
          :variant="disabledAddProduct ? 'outline-secondary' : 'outline-primary'"
          :disabled="disabledAddProduct"
          @click="onClickAddProduct"
        >
          Tambah Produk
        </b-button>
      </div>
      <b-table
        v-if="stokProduk.length > 0"
        :items="stokProduk"
        :fields="selectedProductFields"
        class="mt-2"
        responsive
      >
        <template #cell(variants)="data">
          <div
            v-if="data.item.is_variant"
            class="grid gap-[5px]"
          >
            <div
              v-for="item in data.item.variants"
              :key="`variant_name-${item.warehouse_variant_id}`"
              class="h-[40px] flex items-center"
            >
              {{ item.variant_name }}
            </div>
          </div>
          <div
            v-else
            class="h-[40px] flex items-center"
          >
            -
          </div>
        </template>
        <template #cell(stock)="data">
          <div
            v-if="data.item.is_variant"
            class="grid gap-[5px]"
          >
            <div
              v-for="item in data.item.variants"
              :key="`variant_stock-${item.warehouse_variant_id}`"
              class="h-[40px] flex items-center"
            >
              {{ item.variant_stock }}
            </div>
          </div>
          <div
            v-else
            class="h-[40px] flex items-center"
          >
            {{ data.item.stock }}
          </div>
        </template>
        <template #cell(total)="data">
          <div
            v-if="data.item.is_variant"
            class="grid gap-[5px]"
          >
            <div
              v-for="item in data.item.variants"
              :key="`variant_total-${item.warehouse_variant_id}`"
              class="h-[40px] flex items-center"
            >
              {{ item.total }}
            </div>
          </div>
          <div
            v-else
            class="h-[40px] flex items-center"
          >
            {{ data.item.total }}
          </div>
        </template>
        <template #cell(pengeluaran_cost)="data">
          <div
            v-if="data.item.is_variant"
            class="grid gap-[5px]"
          >
            <div
              v-for="item in data.item.variants"
              :key="`variant_cost-${item.warehouse_variant_id}`"
              class="h-[40px] flex items-center"
            >
              {{ item.cost | rupiah }}
            </div>
          </div>
          <div
            v-else
            class="h-[40px] flex items-center"
          >
            {{ data.item.cost | rupiah }}
          </div>
        </template>
      </b-table>
      <div
        v-if="stokProduk.length > 0"
        class="d-flex justify-end py-2"
      >
        <div class="w-50 space-y-[12px]">
          <div class="d-flex justify-between">
            <div class="text-[20px] font-weight-bolder text-black">
              Total Pembayaran
            </div>
            <div class="text-[20px] font-weight-bolder text-primary ">
              {{ totalPayment | rupiah }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="menuAddProduct">
      <AddProductMenu
        ref="addProductMenu"
        :items="fetcherProducts.data"
        :warehouse-id="String(warehouse)"
        :fetcher="fetcherProducts"
        @backToMainPage="backToMainPage"
        @addProduct="handleAddProduct"
      />
    </div>
  </b-card>
</template>
<script>

import filters from '@/libs/filters'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { Indonesian } from 'flatpickr/dist/l10n/id'
import 'flatpickr/dist/themes/light.css'
import chatButton from '@/libs/chatButton'
import 'vue-select/dist/vue-select.css'
import secureLs from '@/libs/secureLs'
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import AddProductMenu from './components/AddProductMenu.vue'
import { productListFields, selectedProductFields } from './config'

export default {
  components: {
    vSelect,
    flatPickr,
    AddProductMenu,
  },
  filters: { rupiah: filters.rupiah },
  data() {
    return {
      chatButton,
      menuAddProduct: false,
      gudangList: [],
      destinations: [],

      selectAll: false,

      loading: false,
      isSelected: false,
      disabledAddProduct: true,
      selected: [],
      warehouse: '',
      whOptions: [
        {
          value: '',
          text: 'Semua Gudang',
        },
      ],
      barang: [],
      stokProduk: [],
      productListFields,
      selectedProductFields,
      configDate: {
        wrap: true,
        altFormat: 'j F Y',
        altInput: true,
        minDate: 'today',
        altInputClass: 'bg-white form-control',
        locale: Indonesian,
      },
      disabledSave: true,
      disabledMinus: false,
      disabledPlus: false,

      receiverName: '',
      errorInputName: 'Nama penerima wajib diisi',
      receiverPhone: '',
      errorInputPhone: 'No HP wajib diisi',
      receiverDestinationId: '',
      receiverAddressDetail: '',
      errorAddressDetail: 'Alamat detail wajib diisi',
      pickupDate: null,
      ekspedisi: false,
      sendiri: false,
      loadingDestinations: false,
      totalCost: 0,
      totalPayment: 0,
      productCache: {},
    }
  },
  created() {
    this.fetchDataWarehouse()

    this.fetcherProducts = null
    this.initFetcherProducts()

    this.partnerId = secureLs.getItem('userData').partner_detail.id
  },
  methods: {
    async searchDestination(query) {
      if (query.length >= 2) {
        this.loadingDestinations = true
        await this.$http_new.get('/komship/api/v1/inbounds/origins', {
          params: {
            keyword: query,
          },
        })
          .then(res => {
            const { data } = res.data
            this.destinations = data.map(item => ({
              label: item.label,
              value: item.id,
            }))
            this.loadingDestinations = false
          })
          .catch(err => {
            this.loadingDestinations = false
          })
      }
    },
    /**
     * Initialize fetcher products to handle pagination fetching
     */
    initFetcherProducts() {
      const fnFetch = ({
        offset, limit,
      }) => this.$http_new.get(`/komship/api/v1/product-warehouses/partners/${this.partnerId}/warehouses/${this.warehouse}/withdrawal`, {
        params: {
          limit,
          page: offset,
        },
      })
        .then(response => {
          const { data } = response.data

          this.disabledAddProduct = false

          return {
            data,
          }
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal mengambil data produk, refresh halaman untuk mencoba lagi' })
          throw new Error('Gagal mengambil data produk')
        })

      this.fetcherProducts = createPaginatedFetcher(fnFetch, 0, 50)
    },
    async fetchDataWarehouse() {
      await this.$http_komship.get('/v1/komship/outbound/warehouses')
        .then(res => {
          const { data } = res.data
          this.gudangList = [...new Map(
            data.map(obj => [obj.warehouse_id, {
              label: obj.outbound_queue === 1
                ? `${obj.warehouse_name} (Masih ada antrian)`
                : obj.warehouse_name,
              value: obj.warehouse_id,
              disabled: obj.outbound_queue === 1,
            }]),
          ).values()]
        }).catch(() => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Gagal',
                icon: 'AlertCircleIcon',
                text: 'Gagal load data, silahkan coba lagi',
                variant: 'danger',
              },
            },
            2000,
          )
        })
    },
    confirmAjukan() {
      this.$swal({
        title: 'Pengajuan Penarikan barang',
        text: 'Anda yakin menyutujui pengajuan? saldo kamu akan berkurang untuk biaya penarikan barang',
        icon: 'warning',
        width: '50%',
        reverseButtons: true,
        iconHtml: '<img src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png">',
        showCancelButton: true,
        cancelButtonText: 'Batal',
        confirmButtonText: 'Setujui',
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          icon: 'border-0 w-50 my-5',
          confirmButton: 'btn btn-primary px-4',
          cancelButton: 'btn btn-outline-primary mr-1 px-5',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.hitApi()
        }
      })
    },
    async hitApi() {
      const products = this.stokProduk?.map((item, index) => {
        const variant = this.selectedProducts[index]?.variant_ids?.map(variantItem => {
          const variantData = this.productCache[item.product_id]?.variants[variantItem.variant_id]
          return {
            ...variantItem,
            total: variantData?.total || 0,
            cost: variantData?.cost || 0,
          }
        }) || []
        const [total, totalCost] = item.is_variant ? item.variants?.reduce((acc, variantItem) => [acc[0] + variantItem.total, acc[1] + variantItem.cost], [0, 0]) : [item.total, item.cost]
        return {
          id: item.product_id,
          addon_cost: 0,
          addon_minimum: 0,
          modifier: item.modifier,
          is_variant: item.is_variant ? 1 : 0,
          variant,
          variants: item?.variants || [],
          stock: item.stock,
          total,
          totalCost,
          fulfillment_cost: totalCost,
          product_id: item.product_id,
          product_name: item.product_name,
        }
      })

      const payload = {
        partner_id: this.partnerId,
        // eslint-disable-next-line radix
        warehouse_id: parseInt(this.warehouse),
        fulfillment_fee: this.totalPayment,
        shipping_type: this.sendiri ? 1 : 2,
        pickup_date: this.pickupDate === null ? null : this.pickupDate,
        receiver_name: this.receiverName === '' ? null : this.receiverName,
        receiver_phone: this.receiverPhone === '' ? null : this.receiverPhone,
        receiver_destination_id: this.receiverDestinationId === '' ? null : this.receiverDestinationId.value,
        receiver_address_detail: this.receiverAddressDetail === '' ? null : this.receiverAddressDetail,
        products,
      }

      await this.$http_komship.post('/v1/komship/outbound/store', payload)
        .then(res => {
          const { data } = res
          if (data.code === 200) {
            this.$swal({
              title: 'Pengajuan berhasil dikirim',
              text: 'Menunggu persetujuan mitra gudang. untuk koordinasi lebih lanjut kamu bisa menghubungi mitra gudang',
              icon: 'success',
              width: '50%',
              reverseButtons: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              iconHtml: '<img src="https://storage.googleapis.com/komerce/core/icon-popup-success.png">',
              showCancelButton: true,
              cancelButtonText: 'Kembali',
              confirmButtonText: 'Hubungi mitra',
              customClass: {
                icon: 'border-0 w-50 my-5',
                confirmButton: 'btn btn-primary px-4',
                cancelButton: 'btn btn-outline-primary mr-1 px-5',
              },
              buttonsStyling: false,
            }).then(result => {
              if (result.value) {
                this.$router.push({
                  path: '/penarikan-barang',
                })
                this.chatButton(data.data.pic_phone)
              } else {
                this.$router.push({
                  path: '/penarikan-barang',
                })
              }
            })
          } else if (data.code === 400) {
            this.$swal({
              title: 'Pengajuan gagal dikirim',
              text: 'Kamu tidak dapat melakukan pengajuan karena masih memiliki antrian pengajuan',
              icon: 'success',
              width: '50%',
              allowOutsideClick: false,
              allowEscapeKey: false,
              iconHtml: '<img src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png">',
              confirmButtonText: 'Oke',
              customClass: {
                icon: 'border-0 w-50 my-5',
                confirmButton: 'btn btn-primary px-4',
              },
              buttonsStyling: false,
            }).then(result => {
              if (result.value) {
                this.$router.push({
                  path: '/penarikan-barang',
                })
              }
            })
          } else if (data.code === 1006) {
            this.$swal({
              title: 'Pengajuan gagal dikirim',
              text: 'Saldo kamu tidak mencukupi untuk pengajuan penarikan barang, isi saldo kamu yuk...',
              icon: 'success',
              width: '50%',
              reverseButtons: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              iconHtml: '<img src="https://storage.googleapis.com/komerce/assets/icons/fail.svg">',
              showCancelButton: true,
              cancelButtonText: 'Kembali',
              confirmButtonText: 'Top Up',
              customClass: {
                icon: 'border-0 w-50 my-5',
                confirmButton: 'btn btn-primary px-4',
                cancelButton: 'btn btn-outline-primary mr-1 px-5',
              },
              buttonsStyling: false,
            }).then(result => {
              if (result.value) {
                this.$router.push({
                  name: 'saldo',
                })
              } else {
                this.$router.push({
                  path: '/penarikan-barang',
                })
              }
            })
          }
        })
        .catch(() => {})
    },
    formatReceiverName(value) {
      if (value.length === 0) {
        this.errorInputName = 'Nama penerima wajib diisi'
        return value
      }
      const alphabet = value.replace(/[^a-zA-Z ]/g, '')
      if (alphabet.length < 3) {
        this.errorInputName = 'Minimal 3 huruf'
        return alphabet
      }
      this.errorInputName = ''
      return alphabet.slice(0, 30)
    },
    formatAddressDetail(value) {
      if (value.length === 0) {
        this.errorAddressDetail = 'Alamat detail wajib diisi'
        return value
      }
      this.errorAddressDetail = ''
      return value.slice(0, 185)
    },
    formatPhoneNumber(value) {
      if (value.length === 0) {
        this.errorInputPhone = 'No HP wajib diisi'
        return value
      }
      // Replace any non-numeric characters with an empty string
      const numericValue = value.replace(/[^\d]/g, '')

      // check if the number starts with 62
      if (numericValue.startsWith('62')) {
        return numericValue.substr(2)
      }

      // If the first character is not 8, remove it
      if (numericValue[0] !== '8') {
        this.errorInputPhone = 'Harus diawali dengan angka 8'
        return numericValue.slice(1)
      }
      if (numericValue.length < 9) {
        this.errorInputPhone = 'Minimal 9 digit'
        return numericValue
      }

      // Otherwise, return the numeric value
      this.errorInputPhone = ''
      return numericValue.substr(0, 13)
    },
    onClickEkspedisi() {
      this.ekspedisi = true
      this.sendiri = false
      this.pickupDate = null
    },
    onClickSendiri() {
      this.ekspedisi = false
      this.sendiri = true
      this.receiverName = ''
      this.receiverPhone = ''
      this.receiverDestinationId = ''
      this.receiverAddressDetail = ''
    },
    handleDisableAjukan() {
      if (!this.ekspedisi && !this.sendiri) return true
      if (this.ekspedisi) {
        if (this.stokProduk.length === 0 || this.errorInputName || this.errorInputPhone || this.receiverDestinationId === '' || this.errorAddressDetail) {
          return true
        }
        return false
      }
      if (this.sendiri) {
        if (this.stokProduk.length === 0 || this.pickupDate === null) {
          return true
        }
        return false
      }
      return false
    },
    backToMainPage() {
      this.menuAddProduct = false
    },
    onClickAddProduct() {
      this.menuAddProduct = true
    },
    handleAddProduct(payload, totalPayment, selectedProducts, cache) {
      this.$refs.addProductMenu.setPreviousData(selectedProducts, totalPayment)
      this.menuAddProduct = false
      this.stokProduk = payload
      this.totalPayment = totalPayment
      this.selectedProducts = selectedProducts
      this.productCache = cache
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .vs__dropdown-menu {
  max-height: 130px;
}
</style>
<style scoped>
.total {
  width: 25%;
  border-bottom: solid 2px #e2e2e2 !important;
  border: none;
  border-radius: 0;
  outline: none;
  margin: 0px 5px;
  padding: 2px 0px;
  text-align: center;
}
</style>
